import React from 'react'

import { Text, Color, FontFamily, Space, Icon } from '@gousto-internal/citrus-react'

import { DiscountBarContainer, DiscountBarProps } from './DiscountBarContainer'

export const DiscountBar = ({ isHidden, isSticky, applyDiscount, promoText }: DiscountBarProps) => (
  <DiscountBarContainer applyDiscount={applyDiscount} isSticky={isSticky} isHidden={isHidden}>
    <Text color={Color.White} size={4} fontFamily={FontFamily.SemiBold}>
      {promoText}
    </Text>
    <Space direction="horizontal" size={2} />
    <Icon name="arrow_right" style={{ color: Color.White }} />
  </DiscountBarContainer>
)
